import type {
  SearchPartsCompatibleWithErpPartQueryKey,
  SearchPartsCompatibleWithErpPartParams,
} from './types';

export const getSearchPartsCompatibleWithErpPartQueryKey = (
  params: SearchPartsCompatibleWithErpPartParams,
): SearchPartsCompatibleWithErpPartQueryKey => [
  'quotes',
  'importHistoricalWork',
  'searchPartsCompatibleWithErpPart',
  params,
];
